module.exports = __webpack_public_path__ + "media/images/login_lead_sp-7a6acd4b59680d8eb0a182c95c015596.png";